import { useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
// import { RoutePath } from '../../../routes/Routes'
import { UploadImagePreview } from '../../../../components/upload-image-preview/UploadImagePreview'
import StateComponents from '../../../../components/state-component/StateComponents'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import ContainerButton from '../../../../components/button/ContainerButton'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import { formStateHeader, WebsiteStructureApi } from '../../../../api/website-structure/WebsiteStructure.api'
import { alertError, alertSuccess } from '../../../../components/alert/swal'
import { checkPermission, getBaseApi, Translation } from '../../../../utils/app.utils'
import ModalMedia from '../../media/modal-media/ModalMedia'
import { routeName } from '../../../../routes/routeName'
import { RootState } from '../../../../store/store'

type Props = {}



const HeaderStructure = ({ }: Props) => {
    const base_api_image = getBaseApi();

    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();

    // const profileReducer = useSelector((state: RootState) => state.profile.profile);
    // const permission: any[] = profileReducer?.permission || [];
    // const checkPermit = checkPermission('website_structure_header', permission);
    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_HEADER', permission);


    const [showModal, setShowModal] = useState<string>("")
    const [id_header, set_id_header] = useState<number | null>(null);
    const [file_api_url, set_file_api_url] = useState<string>("");
    const [file, setFile] = useState<any[]>([]);
    const [id_media_file, set_id_media_file] = useState<number | null>(null);


    const [formState, setFormState] = useState<formStateHeader>({
        header_name: "",
        header_name_color: "",
        header_name_desc: "",
        header_name_desc_color: "",
        header_desc: "",
        header_desc_color: "",
        id_media_file: null
    })
    const handleChangeFormState = (field: string, value: string) => {
        setFormState((prev) => ({ ...prev, [field]: value }))
    }
    const handleCloseModal = () => {
        setShowModal("");
    }

    const handleSubmit = async (id_media_file?: number) => {
        dispatch(setLoading());
        const body: formStateHeader = {
            ...formState,
            ...(id_media_file && {
                id_media_file: id_media_file
            })
        }
        if (id_header) {
            await WebsiteStructureApi.updatedHeader(id_header, body).then((res) => {
                if (res.status < 300) {
                    handleGetDataHeader();
                    alertSuccess("อัพเดตข้อมูล", "อัพเดตข้อมูลจัดการ Header เรียบร้อย");
                }
            }).catch((err) => {
                console.log(err);
                alertError("Header updated failed!")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await WebsiteStructureApi.createdHeader(body).then((res) => {
                if (res.status < 300) {
                    handleGetDataHeader();
                    alertSuccess("อัพเดตข้อมูล", "อัพเดตข้อมูลจัดการ Header เรียบร้อย");
                }
            }).catch((err) => {
                console.log(err);
                alertError("Header created failed!")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    const handleGetDataHeader = async () => {
        dispatch(setLoading());
        await WebsiteStructureApi.getHeader().then((res) => {
            if (res.status < 300) {
                const data = res.data?.data;
                const url_image: string = `${base_api_image}/${data.header_file?.media_file_path}${data.header_file?.media_file_name}`;
                set_file_api_url(url_image)
                set_id_header(data?.id_header);
                setFormState((prev) => ({
                    ...prev,
                    header_desc: data?.header_desc,
                    header_desc_color: data?.header_desc_color,
                    header_name: data?.header_name,
                    header_name_color: data?.header_name_color,
                    header_name_desc: data?.header_name_desc,
                    header_name_desc_color: data?.header_name_desc_color,
                    id_media_file: data?.id_media_file
                }))
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }


    useEffect(() => {
        handleGetDataHeader();
    }, [])

    
    return (
        <ContainerLayout
            title=''
            titleName='Header'
            buttonContent={
                <ContainerButton
                    justifyContent='flex-end'
                    buttonData={[
                        {
                            seq: 1,
                            buttonProps: {
                                onClick: () => navigate(-1)
                            },
                            key: "BACK",
                            label: "ย้อนกลับ",
                            type: "BACK"
                        },
                        {
                            seq: 2,
                            hidden: !checkPermit.isUpdate,
                            buttonProps: {
                                onClick: () => handleSubmit()
                            },
                            key: "SAVE",
                            label: "บันทึก",
                            type: "SAVE"
                        },
                    ]}
                />
            }
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "โครงสร้างเว็บไซต์",
                                name: "โครงสร้างเว็บไซต์",
                                pathName: "",
                                disabled_match: true
                            },
                            {
                                key: "Header",
                                name: "Header",
                                pathName: routeName.cms_website.website_structure_header,
                            },
                        ]}
                />
            }
            enablePadding
            content={
                <div className='w-full' >
                    <UploadImagePreview
                        heading='ปรับแต่ง Logo'
                        sub_heading='ขนาดภาพที่แนะนำ 84x84px สกุลไฟล์ .png'
                        image_file_blob={file[0]}
                        onChange={(f) => {
                            setFile(f);
                        }}
                        disabled={true}
                        image_file_url={file_api_url}
                        multiple={false}
                        onClick={() => setShowModal("ADD")}
                        onClear={() => {
                            set_file_api_url("");
                            setFile([]);
                        }}
                    />

                    <StateComponents
                        sxContainer={{ mt: 4 }}
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 10
                                },
                                fieldProps: {
                                    heading: "อีเมลติดต่อ",
                                    placeholder: "ระบุ",
                                    value: formState.header_name,
                                    onChange: (e) => handleChangeFormState("header_name", e.target.value)
                                }
                            },
                            {
                                seq: 2,
                                type: "COLOR_PICKER",
                                gridProps: {
                                    xs: 12,
                                    md: 2
                                },
                                fieldProps: {
                                    heading: "สี",
                                    placeholder: "ระบุ",
                                    value: formState.header_name_color,
                                    onChange: (e) => handleChangeFormState("header_name_color", e.target.value)
                                }
                            },
                            {
                                seq: 3,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 10
                                },
                                fieldProps: {
                                    heading: "ที่อยู่ติดต่อ",
                                    placeholder: "ระบุ",
                                    value: formState.header_name_desc,
                                    onChange: (e) => handleChangeFormState("header_name_desc", e.target.value)
                                }
                            },
                            {
                                seq: 4,
                                type: "COLOR_PICKER",
                                gridProps: {
                                    xs: 12,
                                    md: 2
                                },
                                fieldProps: {
                                    heading: "สี",
                                    placeholder: "ระบุ",
                                    value: formState.header_name_desc_color,
                                    onChange: (e) => handleChangeFormState("header_name_desc_color", e.target.value)
                                }
                            },
                            // {
                            //     seq: 5,
                            //     type: "TEXT_FIELD",
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 10
                            //     },
                            //     fieldProps: {
                            //         heading: "ข้อความย่อย",
                            //         placeholder: "ระบุ",
                            //         value: formState.header_desc,
                            //         onChange: (e) => handleChangeFormState("header_desc", e.target.value)
                            //     }
                            // },
                            // {
                            //     seq: 6,
                            //     type: "COLOR_PICKER",
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 2
                            //     },
                            //     fieldProps: {
                            //         heading: "สี",
                            //         placeholder: "ระบุ",
                            //         value: formState.header_desc_color,
                            //         onChange: (e) => handleChangeFormState("header_desc_color", e.target.value)
                            //     }
                            // },
                        ]}
                    />

                    {showModal !== "" && (
                        <ModalMedia
                            open
                            handleClose={handleCloseModal}
                            title='เพิ่มไฟล์'
                            id_media_file={id_media_file}
                            onSelectMediaFile={(_, id) => set_id_media_file(id)}
                            onSubmitMediaFile={(_, id_media_file) => {
                                handleCloseModal();
                                handleSubmit(id_media_file);
                            }}
                            onSubmitLocalFile={(id_media_file) => {
                                handleCloseModal();
                                handleSubmit(id_media_file);
                            }}
                        />
                    )}
                </div>
            }
        />
    )
}

export default HeaderStructure